// src/pages/admin/Relocation.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";

// ฟอร์ม “เชิญประชุมอนุมัติจ่ายเงินปันผล”
import RelocationForm from "../../forms/move/Relocation/Relocation";

function RelocationPage() {
  return (
    <FormWrapper
      title="ย้ายที่ตั้งสำนักงานข้ามจังหวัด"
      FormComponent={RelocationForm}
      formKey="Relocation"
    />
  );
}

export default RelocationPage;
